/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

export const MAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
